import { type PropsWithChildren, useEffect, useRef } from 'react';
import { useIsMounted } from '@toss/react';
import { logger } from '@zep/core-logger';
import { type EventProperties } from '@/utils/analytics';
export const EnterTracking = (props: PropsWithChildren & {
  eventName: string;
  eventProperties?: EventProperties;
  isReady?: boolean;
  onTrack?: () => void;
}) => {
  const {
    eventName,
    eventProperties,
    isReady = true,
    onTrack
  } = props;
  const isMounted = useIsMounted();
  const hasTracked = useRef(false);
  useEffect(() => {
    if (isMounted && isReady && !hasTracked.current) {
      logger.track(eventName, eventProperties);
      hasTracked.current = true;
      onTrack?.();
    }
  }, [eventName, eventProperties, isMounted, isReady, onTrack]);
  return props.children;
};